import { get } from 'api';

import {
  RESET_APPLICATION_TYPE,
  SET_APPLICATION_TYPE,
  SET_USER_SETTINGS,
  USER_SETTINGS_ERROR,
  USER_SETTINGS_LOADING,
} from './actionTypes';

export const initialActionsState = {
  setApplicationType: () => {},
  resetApplicationType: () => {},
  getCurrentUser: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  setApplicationType: (type) => {
    dispatch({
      type: SET_APPLICATION_TYPE,
      payload: type,
    });
  },
  resetApplicationType: () =>
    dispatch({
      type: RESET_APPLICATION_TYPE,
    }),
  getCurrentUser: async () => {
    dispatch({
      type: USER_SETTINGS_LOADING,
    });

    const { data, error } = await get('/user');

    if (!error) {
      dispatch({
        type: SET_USER_SETTINGS,
        payload: data,
      });
    } else {
      dispatch({
        type: USER_SETTINGS_ERROR,
      });
    }
  },
});
